export const DocumentViewOptions = {
    Data: 'data',
    Document: 'document',
    Pdf: 'pdf',
}
